(function($) {
	formHelper.addRule({
		form: '.form-search-mvw-user-searches',
		xhrReady: function() {
			$(".form-search-mvw-user-searches select").each(function() {
				if(this.value.indexOf("ImpersonateMyAccountUser") > -1) {
					window.open(this.value, '_blank');
					this.cancel();
				}
			});
		},
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			}
		}
	});
})(jQuery);

jQuery(function initToolsSearchMVWUserSearches($) {
	$('.search-mvw-user-searches-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-search-mvw-user-searches');

		// Date Created Range
		// ------------------
		var $dateCreatedFrom = $('#date-created-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var dateCreatedFromPicker = $dateCreatedFrom.pickadate('picker');

		var $dateCreatedTo = $('#date-created-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var dateCreatedToPicker = $dateCreatedTo.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( dateCreatedFromPicker.get('value') ) {
			dateCreatedToPicker.set('min', dateCreatedFromPicker.get('select'));
		}
		
		if ( dateCreatedToPicker.get('value') ) {
			dateCreatedFromPicker.set('max', dateCreatedToPicker.get('select'));
		}

		// When something is selected, update the "dateCreatedFrom" and "dateCreatedTo" limits.
		dateCreatedFromPicker.on('set', function(event) {
			if ( event.select ) {
				dateCreatedToPicker.set('min', dateCreatedFromPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				dateCreatedToPicker.set('min', false);
			}
		});

		dateCreatedToPicker.on('set', function(event) {
			if ( event.select ) {
				dateCreatedFromPicker.set('max', dateCreatedToPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				dateCreatedFromPicker.set('max', false);
			}
		});

		// Recent Activity Date Range
		// ------------------
		var $recentActivityFrom = $('#recent-activity-date-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var recentActivityFromPicker = $recentActivityFrom.pickadate('picker');

		var $recentActivityTo = $('#recent-activity-date-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var recentActivityToPicker = $recentActivityTo.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( recentActivityFromPicker.get('value') ) {
			recentActivityToPicker.set('min', recentActivityFromPicker.get('select'));
		}
		
		if ( recentActivityToPicker.get('value') ) {
			recentActivityFromPicker.set('max', recentActivityToPicker.get('select'));
		}

		// When something is selected, update the "recentActivityFrom" and "recentActivityTo" limits.
		recentActivityFromPicker.on('set', function(event) {
			if ( event.select ) {
				recentActivityToPicker.set('min', recentActivityFromPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				recentActivityToPicker.set('min', false);
			}
		});

		recentActivityToPicker.on('set', function(event) {
			if ( event.select ) {
				recentActivityFromPicker.set('max', recentActivityToPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				recentActivityFromPicker.set('max', false);
			}
		});

		// Recent Hold Activity Date Range
		// ------------------
		var $recentHoldActivityFrom = $('#recent-hold-activity-date-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var recentHoldActivityFromPicker = $recentHoldActivityFrom.pickadate('picker');

		var $recentHoldActivityTo = $('#recent-hold-activity-date-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var recentHoldActivityToPicker = $recentHoldActivityTo.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( recentHoldActivityFromPicker.get('value') ) {
			recentHoldActivityToPicker.set('min', recentHoldActivityFromPicker.get('select'));
		}
		
		if ( recentHoldActivityToPicker.get('value') ) {
			recentHoldActivityFromPicker.set('max', recentHoldActivityToPicker.get('select'));
		}

		// When something is selected, update the "recentActivityFrom" and "recentActivityTo" limits.
		recentHoldActivityFromPicker.on('set', function(event) {
			if ( event.select ) {
				recentHoldActivityToPicker.set('min', recentHoldActivityFromPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				recentHoldActivityToPicker.set('min', false);
			}
		});

		recentHoldActivityToPicker.on('set', function(event) {
			if ( event.select ) {
				recentHoldActivityFromPicker.set('max', recentHoldActivityToPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				recentHoldActivityFromPicker.set('max', false);
			}
		});
	});
});

jQuery(function initToolsSearchMVWUserSearchesResults($) {
	$('.search-mvw-user-searches-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-search-mvw-user-searches-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});